import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'accredible-navigation-back',
  standalone: true,
  imports: [AccredibleIconComponentModule],
  templateUrl: './navigation-back.component.html',
  styleUrls: ['./navigation-back.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationBackComponent {
  text = input.required<string>();
  textColor = input<string>('var(--primary-color)');
  backUrl = input<string>();
  useCustomNav = input<boolean>();

  protected readonly _location = inject(Location);
  protected readonly _router = inject(Router);

  goBack(): void {
    if (this.useCustomNav()) return;

    if (this.backUrl()) {
      this._router.navigate([this.backUrl()]);
    } else {
      this._location.back();
    }
  }
}
